window.luiReferenceControllers = window.luiReferenceControllers || [];
window.luiReferenceControllers.push(function (application, Stimulus) {
    application.register("comp_references_single_progress-medical", class extends Stimulus.Controller {


    connect() {
        const self = this;

        const options = {
            root: null,
            rootMargin: '10px',
            threshold: 0.2
        };

        const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('animate');
                    observer.unobserve(entry.target);
                } else {
                    entry.target.classList.remove('animate');
                }
            });
        }, options);
        // static targets = ["observeItem"]

        self.targets.findAll('observeItem').forEach(item => {
            observer.observe(item);
        });
    }

  
})
});
window.luiRegisterReferenceControllers && window.luiRegisterReferenceControllers();
